const state = sessionStorage.getItem('state')?.tagsView ? JSON.parse(sessionStorage.getItem('state')).tagsView : {
  // 访问的页签
  visitedViews: [],
  // 缓存的页签
  cachedViews: [],
  openChart: false
}

const mutations = {
  // 添加访问页面
  /**
   * 添加访问页面
   * @param state
   * @param view
   * @constructor
   */
  ADD_VISITED_VIEW: (state, view) => {
    if (state.visitedViews.some(v => v.url === view.url)) return
    state.visitedViews.push({
      ...view,
      title: view.name || "no-name"
    })
  },
  /**
   * 添加缓存页面
   * @param state
   * @param view
   * @constructor
   */
  ADD_CACHED_VIEW: (state, view) => {
    if (state.cachedViews.includes(view.name)) return
    state.cachedViews.push(view.name)
  },
  /**
   * 删除表单
   * @param state
   * @param view
   * @constructor
   */
  DEL_VISITED_VIEW: (state, view) => {
    for (const [i, v] of state.visitedViews.entries()) {
      if (v.url === view.url) {
        state.visitedViews.splice(i, 1)
        break
      }
    }
  },
  DEL_CACHED_VIEW: (state, view) => {
    const index = state.cachedViews.indexOf(view.name)
    index > -1 && state.cachedViews.splice(index, 1)
  },
  DEL_OTHERS_VISITED_VIEWS: (state, view) => {
    state.visitedViews = state.visitedViews.filter(v => {
      return v.affix || v.url === view.url
    })
  },
  DEL_OTHERS_CACHED_VIEWS: (state, view) => {
    const index = state.cachedViews.indexOf(view.name)
    if (index > -1) {
      state.cachedViews = state.cachedViews.slice(index, index + 1)
    } else {
      // if index = -1, there is no cached tags
      state.cachedViews = []
    }
  },
  // 删除全部访问
  DEL_ALL_VISITED_VIEWS: state => {
    // keep affix tags
    // const affixTags = state.visitedViews.filter(tag => {
    //
    //   tag.meta.affix
    // })
    // state.visitedViews = affixTags
    const affixTags = []
    state.visitedViews.filter(tag => {
      if (tag.affix === "true") {
        affixTags.push(tag)
      }
    })
    state.visitedViews = affixTags
  },
  // 删除全部缓存
  DEL_ALL_CACHED_VIEWS: state => {
    state.cachedViews = []
  },
  UPDATE_VISITED_VIEW: (state, view) => {
    for (let v of state.visitedViews) {
      if (v.path === view.path) {
        v = Object.assign(v, view)
        break
      }
    }
  },
  OPEN_CHART: (state) => {
    state.openChart = !state.openChart
  }
}

const actions = {
  /**
   * 添加页面访问记录
   * @param dispatch
   * @param view
   */
  addView({ dispatch }, view) {
    dispatch('addVisitedView', view)
    dispatch('addCachedView', view)
  },
  /**
   * 添加访问记录
   * @param commit
   * @param view
   */
  addVisitedView({ commit }, view) {
    commit('ADD_VISITED_VIEW', view)
  },
  /**
   * 缓存访问记录
   * @param commit
   * @param view
   */
  addCachedView({ commit }, view) {
    commit('ADD_CACHED_VIEW', view)
  },
  delView({ dispatch, state }, view) {
    return new Promise(resolve => {
      dispatch('delVisitedView', view)
      dispatch('delCachedView', view)
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      })
    })
  },
  delVisitedView({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_VISITED_VIEW', view)
      resolve([...state.visitedViews])
    })
  },
  delCachedView({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_CACHED_VIEW', view)
      resolve([...state.cachedViews])
    })
  },
  delOthersViews({ dispatch, state }, view) {
    return new Promise(resolve => {
      dispatch('delOthersVisitedViews', view)
      dispatch('delOthersCachedViews', view)
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      })
    })
  },
  delOthersVisitedViews({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_OTHERS_VISITED_VIEWS', view)
      resolve([...state.visitedViews])
    })
  },
  delOthersCachedViews({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_OTHERS_CACHED_VIEWS', view)
      resolve([...state.cachedViews])
    })
  },
  delAllViews({ dispatch, state }, view) {
    return new Promise(resolve => {
      dispatch('delAllVisitedViews', view)
      dispatch('delAllCachedViews', view)
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      })
    })
  },
  delAllVisitedViews({ commit, state }) {
    return new Promise(resolve => {
      commit('DEL_ALL_VISITED_VIEWS')
      resolve([...state.visitedViews])
    })
  },
  delAllCachedViews({ commit, state }) {
    return new Promise(resolve => {
      commit('DEL_ALL_CACHED_VIEWS')
      resolve([...state.cachedViews])
    })
  },
  updateVisitedView({ commit }, view) {
    commit('UPDATE_VISITED_VIEW', view)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters: {
    /**
     * 获取访问过的页面
     * @param state
     */
    getVisitedViews(state) {
      return state.visitedViews
    }
  }
}
